import React from "react";
import PropTypes from "prop-types";

// import store, actions
import { connect } from "react-redux";
import {
  setAppTokenAsked,
  setAppTokenRetrieved,
  setSchool,
  togglePreloader,
} from "../../store/actions";

// import deep-equal
import equal from "deep-equal";

// import services
import { getSchools } from "../../services/schoolService";

// import common components
import Banner from "../../components/common/Banner";
import Leading from "../../components/common/Leading";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import Section from "../../components/common/Section";

// import custom components
import ListSchool from "../../components/custom/schools/ListSchool";
import FilterSchool from "../../components/custom/schools/FilterSchool";

// import constants
import { APP_TOKEN } from "../../helpers/constants";

// import utilities
import {
  isNotEmptyArray,
  isUnauthenticatedRequest,
} from "../../helpers/utilities";

class Schools extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    try {
      //Get props
      let { onPreloaderToggled, onAppTokenAsked } = this.props;

      //Start preload
      onPreloaderToggled(true, "Chargement des établissements");

      //Check app token
      if (!localStorage.getItem(APP_TOKEN)) onAppTokenAsked();
      else this.onGetSchools(); //Launch request
    } catch (error) {
      console.error(error);
    }
  }

  componentDidUpdate(prevProps) {
    try {
      if (!equal(prevProps, this.props)) {
        //Get props
        let { tokenRetrieved, tokenFailed, onPreloaderToggled, schools } =
          this.props;

        //Check app token retrieved
        if (
          tokenRetrieved &&
          localStorage.getItem(APP_TOKEN) &&
          !isNotEmptyArray(schools)
        )
          this.onGetSchools();
        else if (tokenFailed) onPreloaderToggled(false, ""); //Stop preload
      }
    } catch (error) {
      console.error(error);
    }
  }

  componentWillUnmount() {
    try {
      //Reset props
      this.props.onSetSchools([]);
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Get schools.
   *
   */
  onGetSchools() {
    //Get props
    let { onSetSchools, onPreloaderToggled, onAppTokenAsked } = this.props;

    //Launch requests
    getSchools()
      .then((response) => {
        if (isUnauthenticatedRequest(response)) {
          onAppTokenAsked();
        } else {
          if (response && response.data) onSetSchools(response.data);
          else console.error(response, "GET SCHOOLS ERROR");
          onPreloaderToggled(false, "");
        }
      })
      .catch((error) => {
        onPreloaderToggled(false, "");
        console.error(error, "GET SCHOOLS ERROR");
      });
  }

  /**
   * On Filtered.
   *
   * @param {*} data
   */
  onFiltered = (data) => {
    try {
      let { levels, sectors, location } = data;
      let { alls, onSetSchools } = this.props;

      let searcheds_list = alls.filter((item) => {
        return `${item.city} ${item.country.name}`.includes(location.trim());
      });

      onSetSchools({ searcheds: searcheds_list });
    } catch (error) {
      console.error(error);
    }
  };

  /**
   * On Reseted.
   *
   */
  onReseted = () => {
    try {
      let { alls, onSetSchools } = this.props;
      onSetSchools({ searcheds: alls });
    } catch (error) {
      console.error(error);
    }
  };

  render() {
    const { schools, isPreloader } = this.props;
    console.log("working",{ schools, isPreloader })
    return (
      <React.Fragment>
        <div id="schools" className={`${isPreloader ? "d-none" : "d-block"}`}>
          {isNotEmptyArray(schools) ? (
            <div id="schools-content">
              {/* Banner, Leading */}
              <Banner bannerId="schools-banner">
                <Leading
                  title="Nos établissements"
                  subtitle="Trouvez votre école ou université"
                />
              </Banner>

              {/* Breadcrumbs */}
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <Breadcrumbs
                      subtitle="Annuaire"
                      currentTile="Tous les établissements"
                    />
                  </div>
                </div>
              </div>

              {/* Contenu */}
              <Section
                subtitle="Liste de tous les établissements référencés"
                sectionId="page-schools"
                sectionClasses="page-schools py-5"
              >
                <FilterSchool
                  onFiltered={this.onFiltered}
                  onReseted={this.onReseted}
                />

                <ListSchool items={schools} />
              </Section>
            </div>
          ) : (
            <div className="container">
              <div className="row py-5">
                <div className="col-lg-12 py-5">
                  <center>
                    <p className="mb-0 p-2">
                      La liste de nos établissements référencés bientôt
                      disponible.
                    </p>
                    <p className="mb-0 p-2">
                      Continuer sur <a href="/">l'accueil</a>
                    </p>
                  </center>
                </div>
              </div>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
}
Schools.propTypes = {
  alls: PropTypes.array,
  schools: PropTypes.array,
  onSetSchools: PropTypes.func,
  isPreloader: PropTypes.bool,
  tokenFailed: PropTypes.bool,
  tokenRetrieved: PropTypes.bool,
};
const mapStateToProps = (state) => ({
  alls: state.schools,
  schools: state.searched_schools,
  tokenRetrieved: state.tokenRetrieved,
  tokenFailed: state.tokenFailed,
  isPreloader: state.isPreloader,
});
const mapDispatchToProps = (dispatch) => ({
  onSetSchools: (data) => dispatch(setSchool(data)),
  onAppTokenAsked: (data) => dispatch(setAppTokenAsked(data)),
  onAppTokenRetrieved: (data) => dispatch(setAppTokenRetrieved(data)),
  onPreloaderToggled: (preload, message) =>
    dispatch(togglePreloader(preload, message)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Schools);
